import React from 'react'
import imgJob from '../../../assets/imgs/job-description.png'
import './job-description-box.scss'
import JobDescriptionItem from '../job-description-item/JobDescriptionItem'
import AppContainer from '../../../component/layout/AppContainer.tsx'

const JobDescriptionBox = () => {
  return (
    <AppContainer className="job-description">
      <div className="boxWrapper-header">
        <h2 className="title__container">Job description</h2>
      </div>
      <div className="jobContent">
        <div className="imgJobBox">
          <img className="imgJobContent" alt="job" src={imgJob} />
        </div>
        <div className="text-content">
          <JobDescriptionItem description="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor…" />
          <JobDescriptionItem description="Test" />
          <JobDescriptionItem description="Another test" />
        </div>
      </div>
    </AppContainer>
  )
}
export default JobDescriptionBox
